import {isArray} from "underscore";

class ResponseMaker {
    data = {
        projectWiseBomList: []
    };
    data_to_send = {
        total_bom: 0,
        your_bom_listing: {},
        your_bom_listing_with_project: {},
        project_listing: {},
        bom_listing_with_project: {},
    };

    constructor(data) {
        this.data = data;
    }

    process = () => {
        if (this.data.yourBomList !== undefined && this.data.yourBomList.length > 0) {
            this.data.yourBomList.map((v) => {
                v['isDownloadLoad'] = false;
                this.data_to_send.your_bom_listing[v.bomId] = v;
            })
        }
        if (this.data.totalBoms) {
            this.data_to_send.total_bom = this.data.totalBoms;
        }
        if (this.data.projectList !== undefined && this.data.projectList.length > 0) {
            this.data.projectList.map((v) => {
                let bom_listing = {};
                if (isArray(v.bomList)) {
                    v.bomList.map((b_v) => {
                        b_v['isDownloadLoad'] = false; // all project list
                        bom_listing[b_v.bomId] = b_v;
                    })
                }
                this.data_to_send.project_listing[v.projectId] = {...v, bom_listing};
            })
        }
        return this;
    };

    run = () => {
        return this;
    };

    get = () => {
        return this.data_to_send;
    };
}

export default ResponseMaker;